import { useAgentHold, setRemindersHold, useToast } from '@elva/ui';

/** Holding Appointment Reminders (amendment 25 §6 → specs 36 + 37, shared store). */
export function useRemindersHold(): { onHold: boolean; setHold: (next: boolean) => void } {
  const hold = useAgentHold('reminders');
  const { toast } = useToast();

  return {
    onHold: hold.held,
    setHold: (next: boolean) => {
      setRemindersHold(next);
      toast({
        title: next ? 'Appointment Reminders is on hold' : 'Appointment Reminders is working again — 38 held messages go at their next window',
        variant: next ? 'warning' : 'success',
      });
    },
  };
}
